import React from 'react';
import { FieldArray as FormikFieldArray } from 'formik';
import { FieldArrayProps } from 'components/shared/form/FieldArray/FIeldArray.types';

export const FieldArray = ({ children, name }: FieldArrayProps) => {
  return <FormikFieldArray name={name} render={(props) => children(props)} />;
};
